import { getPrefixedUrl } from '@utilities/get-prefixed-url';

const API_ENDPOINT = '/umbraco/surface/account/buyerstatus';

type UserBuyerStatus = 'hasPreference' | 'isReserveCandidate' | 'hasOption' | 'none';

const fetchBuyerStatus = async (
    accountId: string,
    constructionNumberId: string,
): Promise<UserBuyerStatus | undefined> => {
    const url = `${API_ENDPOINT}?accountId=${accountId}&constructionNumberId=${constructionNumberId}`;

    try {
        const response = await fetch(getPrefixedUrl(url)).then((r) => r.json());
        if (!response) return;
        return response.status as UserBuyerStatus;
    } catch {
        return;
    }
};

export { fetchBuyerStatus, UserBuyerStatus };
